module.exports = __webpack_public_path__ + "img/address-sentosa.17dc4074.svg";